import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { usePositionCount } from '../hooks/use-position-count';

export const PositionCount: React.FC = () => {
  const { t } = useTranslation();
  const { selected, total, supplierWarning } = usePositionCount();

  return (
    <>
      <Typography variant="body2" color="var(--text03)">
        {t('COMMON.ERP.CONVERT.SELECTED_INFO_COUNT', {
          positions: selected,
          orders: total,
        })}
      </Typography>

      {supplierWarning && (
        <Tooltip title={t('COMMON.ERP.CONVERT.SUPPLIER_WARNING')}>
          <div style={{ padding: '0 0.5rem' }}>
            <WarningIcon color="error" />
          </div>
        </Tooltip>
      )}
    </>
  );
};
